// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__XnL2T","cateog":"Footer_cateog__f7cfU","copyright":"Footer_copyright__te2dN"};